import React, { Component } from "react";
import {validateSession} from "./../actions/login";
import {withRouter} from "react-router";
import {Redirect} from "react-router-dom";
import {connect} from "react-redux";
import {fetchUser, userSave, usersList, fetchUsersList, usersFind, usersExport, userDelete} from "../actions/users";
import {fetchProjects,fetchProjectsList, fetchProjectEdit, projectSave, fetchProjectsGoalsEdit, projectGoalsSave,
	fetchProjectsExpensesEdit, projectsExpensesSave, fetchProjectPhasesGroupsEdit, projectPhaseSave, projectPhaseDelete,
	fetchProjectEmployeesEdit, projectEmployeeEditSave, projectEmployeeDelete, projectsExport, fetchProjectCommission,
	projectsFolios, projectsFoliosAssign} from "../actions/projects";
import {
	fetchCompletProject, projectAgency, projectAgencyExport,projectAgencySave, projectConclusion, projectConclusionSave,
	projectConclusionExport,projectEmployees,
	projectEmployeeSave,projectOwner, projectOwnerSave, projectRegistry, projectRegistryData,
	projectRegistrySave, projectProigualdadGoals, projectProigualdadGoalsEdit, projectProigualdadGoalsEditSave,
	/*projectFiscalEntity, projectFiscalEntitySave, fetchDispersions, projectDispersionsSave,*/
	projectExpenses, projectExpensesSave
} from "../actions/project";
import {
	projectAgreements,
	projectAgreementsSave,
	projectAgreementsExport,
	fetchProjectAgreementsWithRevision
} from '../actions/agreements';
import {projectDispersions, projectDispersionsExport, projectDispersionsSave} from "../actions/dispersions";
import {statusGroupList, statusList, statusMotivesList} from "../actions/status";
import {roleDelete, fetchRole, roleSave, rolesShow, fetchRolesList} from "../actions/roles";
import { entitiesShow, entitiesList, entityDelete, entityEdit, entitySave} from "../actions/entities";
import {
	municipalitiesList, municipalitiesShow, municipalityDelete, municipalityEdit,
	municipalitySave
} from "../actions/municipalities";
import {agenciesShow, agencyEdit, agencyEditSave, agencyDelete, fetchAgencyMunicipalities} from "../actions/agencies";
import {amountsAgenciesShow, amountsAgenciesEdit, amountsAgenciesEditSave, amountAgencyDelete} from "../actions/amounts_agencies";
import { actions } from "react-redux-form";
import {fetchVersionsShow, versionsList, fetchVersion, versionSave, versionDelete} from "../actions/versions";
import {fetchVersionGroupPhaseComplete, fetchVersionGroupsPhases, versionGroupsPhasesEditSave} from '../actions/version_groups_phases';
import {permissionDelete, permissionEdit, permissionSave, permissionsList, permissionsShow} from "../actions/permissions";
import {fetchProfile, profileUpdate} from "../actions/profile";
import {phaseDelete, phaseEdit, phasesShow, phasesList, phaseSave} from "../actions/phases";
import {modalitiesList} from "../actions/modalities";
import {fetchGoalComplete, goalSave, goalDelete, goalsList, goalsShow} from "../actions/goals";
import {objectivesShow, objectivesList,objectiveEdit, objectiveEditSave, objectiveDelete} from "../actions/objectives";
import {strategiesShow, strategiesList, strategieEdit, strategieEditSave, strategieDelete} from "../actions/strategies";
import {axisShow, axisList, axisEdit, axisEditSave, axisDelete} from "../actions/axis";
import {linesShow, linesList, lineEdit, lineEditSave, lineDelete, fetchLineComplete} from "../actions/lines";
import {fetchActivityComplete, activitiesList, activitiesShow, activityDelete, fetchActivity, activitySave,
	goalActivitiesList} from "../actions/activities";
import {conceptDelete, fetchConcept, conceptSave, conceptsShow, conceptsList} from "../actions/concepts";
import { showModal, hideModal } from "./../actions/modal";
import {verificationMediaShow} from "../actions/verification_media";
import {activityGroupShow} from "../actions/activity_groups";
import {actorsList, actorsGroups, conagoList} from "../actions/directories";
import {resourceConceptsList} from "../actions/resource_concept";
import {clearNotification, newNotification} from "../actions/notifications";
import {fetchRevision, fetchRevisionLegal, fetchRevisionProject,fetchRevisionReports, saveLegalRevision, saveProjectRevision, fetchCommission, assignCommission, surveysSaveAnswer,
		fetchShowCommission, fetchRevisionAgreements, saveAgreements, saveRevisionReportsFinancial, saveRevisionReportsExpenses, saveRevisionReportsSummary} from "../actions/revision";
import { notificationMessagesFetch, notificationMessagesSave, notificationStateReviewedSave,
	notificationAssignFolios, notificationTypesFetch, notificationMessagesExport } from "../actions/notification_messages";
import {fetchNotificationsTypes,fetchNotificationsTypesList, notificationTypeEdit, notificationTypeEditSave, } from "../actions/notifications_types";
import { surveysShow, fetchSurveysList, surveysFetchTypes,fetchSurvey, surveySave, surveyDelete} from "../actions/surveys";
import { fetchGroupsPhasesShow, fetchGroupsPhasesList,fetchGroupPhaseEdit, groupPhaseSave, groupPhaseDelete } from "../actions/groups_phases";
import { reportsFinancial, financialGoalStatusSave, financialGoalDocumentSave, financialActivityStatusSave, financialGoalInvoicesSave,
	financialActivityMediaSave, financialGoalDocumentDelete, financialGoalInvoiceDelete, financialActivityMediaDelete,
	reportsExpenses, expenseInvoicesSave, expensesInvoiceDelete, expenseReceiptsSave, expensesReceiptDelete,reportsEmployees, reportsEmployeeAdd,
	reportsEmployeeInvoicesSave, reportsEmployeeInvoiceDelete, reportsSummary, reportsSummaryExport, reportsSummarySave,
	reportsSurvey, reportsSurveySave, financialGoalActorsSave, financialGoalConagoSave} from "../actions/reports";
import {documentsTypesShow} from "../actions/documents_types";
import {cdmEmployees, cdmEmployeesSave} from "../actions/cdms";
import {hideMenu, showMenu} from "../actions/menu";

export default function (WrappedComponent) {
	class SecureLayout extends Component {

		/*componentWillMount() {
			this.props.validateSession();
		}*/

		render() {
			let {checked, authenticated} = this.props.session;
			return (checked && authenticated) ? <WrappedComponent {...this.props} authenticated={authenticated} /> :
				<Redirect to={{pathname: "/", state: { from: this.props.location.pathname }}} />
		}
	}

	return withRouter(connect(mapStateToProps, mapDispatchToProps)(SecureLayout));
}

const mapStateToProps = state => {
	return { ...state }
}

const mapDispatchToProps = dispatch => {
	return {
		validateSession: () => {
			dispatch(validateSession())
		},
		usersList: (page, filters/*, search*/) => {
			dispatch(usersList(page, filters/*, search*/));
		},
		fetchUsersList: () => {
			dispatch(fetchUsersList())
		},
		projectConclusion: (modality, state, mun) => {
			dispatch(projectConclusion(modality, state, mun))
		},
		projectConclusionExport: (modality, state, mun) => {
			dispatch(projectConclusionExport(modality, state, mun))
		},
		projectConclusionSave: (modality, state, mun, values, event) => {
			dispatch(projectConclusionSave(modality, state, mun, values, event));
		},
		fetchUser: (id) => {
			dispatch(fetchUser(id));
		},
		usersFind: (value) => {
			dispatch(usersFind(value))
		},
		usersExport: (filters) => {
			dispatch(usersExport(filters))
		},
		userDelete: (id) => {
			dispatch(userDelete(id))
		},
		fetchStatus: (group) => {
			dispatch(statusGroupList(group))
		},
		statusList: () => {
			dispatch(statusList())
		},
		statusMotivesList: () => {
			dispatch(statusMotivesList())
		},
		rolesShow: (value) => {
			dispatch(rolesShow(value));
		},
		fetchRolesList: () => {
			dispatch(fetchRolesList())
		},
		userSave: (data) => {
			dispatch(userSave(data));
		},
		entitiesShow: (value, filters) => {
			dispatch(entitiesShow(value, filters))
		},
		fetchEntities: () => {
			dispatch(entitiesList());
		},
		fetchEntity: (id) => {
			dispatch(entityEdit(id))
		},
		entitySave: (values) => {
			dispatch(entitySave(values))
		},
		deleteEntity: (id) => {
			dispatch(entityDelete(id))
		},
		resetEntity: () => {
			dispatch(actions.reset('entities.edit'));
		},
		fetchMunicipalities: (state) => {
			dispatch(municipalitiesList(state))
		},
		filterMunicipalities: (state) => {
			dispatch(municipalitiesList(state, true))
		},
		municipalitiesShow: (page, filters) => {
			dispatch(municipalitiesShow(page, filters))
		},
		deleteMunicipality: (id) => {
			dispatch(municipalityDelete(id))
		},
		municipalitySave: (values) => {
			dispatch(municipalitySave(values))
		},
		resetMunicipalities: () => {
			dispatch(actions.reset('municipalities.edit'));
			dispatch(actions.reset('municipalities.list'));
		},
		agenciesShow: (page, filters) => {
			dispatch(agenciesShow(page, filters))
		},
		agencyEdit: (id) => {
			dispatch(agencyEdit(id))
		},
		agencyEditSave: (values) => {
			dispatch(agencyEditSave(values))
		},
		agencyDelete: (id) => {
			dispatch(agencyDelete(id))
		},
		fetchAgencyMunicipalities: (entity) => {
			dispatch(fetchAgencyMunicipalities(entity))
		},
		amountsAgenciesShow: (page, filters) => {
			dispatch(amountsAgenciesShow(page, filters))
		},
		amountsAgenciesEdit: (id) => {
			dispatch(amountsAgenciesEdit(id))
		},
		amountsAgenciesEditSave: (values) => {
			dispatch(amountsAgenciesEditSave(values))
		},
		amountAgencyDelete: (id) => {
			dispatch(amountAgencyDelete(id))
		},
		resetUser: () => {
			dispatch(actions.reset('users.edit'));
			dispatch(actions.reset('users.list'));
		},
		fetchVersionsShow: (value) => {
			dispatch(fetchVersionsShow(value));
		},
		versionsList: () => {
			dispatch(versionsList())
		},
		fetchVersion: (year) => {
			dispatch(fetchVersion(year))
		},
		versionSave: (values) => {
			dispatch(versionSave(values))
		},
		versionDelete: (year) => {
			dispatch(versionDelete(year))
		},
		resetVersions: () => {
			dispatch(actions.reset('versions.edit'));
			dispatch(actions.reset('versions.list'));
		},
		fetchVersionGroupPhaseComplete: (year, id) => {
			dispatch(fetchVersionGroupPhaseComplete(year, id))
		},
		fetchVersionGroupsPhases: (year, id) => {
			dispatch(fetchVersionGroupsPhases(year, id))
		},
		versionGroupsPhasesEditSave: (year, values) => {
			dispatch(versionGroupsPhasesEditSave(year, values))
		},
		deleteRole: (id) => {
			dispatch(roleDelete(id))
		},
		fetchPermissions: () => {
			dispatch(permissionsList())
		},
		fetchRole: (id) => {
			dispatch(fetchRole(id))
		},
		roleSave: (values) => {
			dispatch(roleSave(values))
		},
		resetRolesList: () => {
			dispatch(actions.reset('roles.edit'));
			dispatch(actions.reset('roles.list'));
		},
		fetchProfile: () => {
			dispatch(fetchProfile())
		},
		profileSave: (values) => {
			dispatch(profileUpdate(values))
		},
		phasesShow: (page) => {
			dispatch(phasesShow(page))
		},
		phasesList: () => {
			dispatch(phasesList())
		},
		phaseDelete: (id) => {
			dispatch(phaseDelete(id))
		},
		phaseEdit: (id) => {
			dispatch(phaseEdit(id))
		},
		phaseSave:(values) => {
			dispatch(phaseSave(values))
		},
		permissionsShow: (page) => {
			dispatch(permissionsShow(page))
		},
		deletePermission: (id) => {
			dispatch(permissionDelete(id))
		},
		permissionEdit: (id) => {
			dispatch(permissionEdit(id))
		},
		permissionsSave: (values) => {
			dispatch(permissionSave(values));
		},
		resetPermissionEdit: () => {
			dispatch(actions.reset('permissions.edit'));
			dispatch(actions.reset('permissions.list'));
		},
		fetchMunicipality: (id) => {
			dispatch(municipalityEdit(id))
		},
		fetchModalities: () => {
			dispatch(modalitiesList())
		},
		goalsShow: (page, filters) => {
			dispatch(goalsShow(page, filters))
		},
		fetchGoalsList: (id) => {
			dispatch(goalsList(id));
		},
		deleteGoal: (id) => {
			dispatch(goalDelete(id))
		},
		objectivesShow: (page, filters) => {
			dispatch(objectivesShow(page, filters))
		},
		objectivesList: () => {
			dispatch(objectivesList())
		},
		objectiveEdit: (id) => {
			dispatch(objectiveEdit(id))
		},
		objectiveEditSave: (values) => {
			dispatch(objectiveEditSave(values))
		},
		objectiveDelete: (id) => {
			dispatch(objectiveDelete(id))
		},
		strategiesShow: (page, filters) => {
			dispatch(strategiesShow(page,filters))
		},
		strategiesList: () => {
			dispatch(strategiesList())
		},
		strategieEdit: (id) => {
			dispatch(strategieEdit(id))
		},
		strategieEditSave: (values) => {
			dispatch(strategieEditSave(values))
		},
		strategieDelete: (id) => {
			dispatch(strategieDelete(id))
		},
		linesShow: (page, filters) => {
			dispatch(linesShow(page, filters))
		},
		linesList: () => {
			dispatch(linesList())
		},
		lineEdit: (id) => {
			dispatch(lineEdit(id))
		},
		lineEditSave: (values) => {
			dispatch(lineEditSave(values))
		},
		lineDelete: (id) => {
			dispatch(lineDelete(id))
		},
		fetchLineComplete: (id) => {
			dispatch(fetchLineComplete(id))
		},
		axisShow: (page, filters) => {
			dispatch(axisShow(page, filters))
		},
		axisList: () => {
			dispatch(axisList())
		},
		axisEdit: (id) => {
			dispatch(axisEdit(id))
		},
		axisEditSave: (values) => {
			dispatch(axisEditSave(values))
		},
		axisDelete: (id) => {
			dispatch(axisDelete(id))
		},
		activitiesList: () => {
			dispatch(activitiesList());
		},
		activitiesShow: (page, filters) => {
			dispatch(activitiesShow(page, filters));
		},
		fetchActivityComplete: (id) => {
			dispatch(fetchActivityComplete(id))
		},
		fetchActivity: (id) => {
			dispatch(fetchActivity(id));
		},
		saveActivity: (values) => {
			dispatch(activitySave(values))
		},
		deleteActivity: (id) => {
			dispatch(activityDelete(id))
		},
		mediaList: () => {
			dispatch(verificationMediaShow())
		},
		activityGroupShow: () => {
			dispatch(activityGroupShow())
		},
		fetchGoalComplete: (id) => {
			dispatch(fetchGoalComplete(id))
		},
		goalSave: (values) => {
			dispatch(goalSave(values));
		},
		change: (model,value) => {
			dispatch(actions.change(model,value))
		},
		resetGoalActivities: () => {
			dispatch(actions.reset('activities.list'));
			dispatch(actions.reset('activities.pages'));
		},
		resetActivityEdit: () => {
			dispatch(actions.reset('activities.edit'));
		},
		resetGoalId: () => {
			dispatch(actions.reset('project.registry,goal_id'))
		},
		resetGoals: () => {
			dispatch(actions.reset('goals.edit'));
			dispatch(actions.reset('goals.list'));
		},
		conceptsShow: (page, filters) => {
			dispatch(conceptsShow(page, filters))
		},
		conceptsList: () => {
			dispatch(conceptsList())
		},
		deleteConcept: (id) => {
			dispatch(conceptDelete(id))
		},
		fetchConcept: (id) => {
			dispatch(fetchConcept(id))
		},
		resetConcepts: () => {
			dispatch(actions.reset('concepts.edit'));
		},
		conceptSave: (values) => {
			dispatch(conceptSave(values))
		},
		showModal: () => {
			dispatch(showModal());
		},
		hideModal: () => {
			dispatch(hideModal());
		},
		fetchState: (id) => {
			dispatch(entityEdit(id))
		},
		fetchOwner: (modality, state, mun) => {
			dispatch(projectOwner(modality, state, mun))
		},
		saveOwner: (modalidty, state, mun, data, event) => {
			dispatch(projectOwnerSave(modalidty, state, mun, data, event))
		},
		fetchAgency: (modality, state, mun) => {
			dispatch(projectAgency(modality, state, mun))
		},
		projectAgencyExport: (modality, state, mun) => {
			dispatch(projectAgencyExport(modality, state, mun))
		},
		saveAgency: (modality, state, mun, values, event) => {
			dispatch(projectAgencySave(modality, state, mun, values, event))
		},/*
		addProjectGoal: (value) => {
			dispatch(actions.push('project.registry.data.goals',value))
		},
		addProjectResourseConcept: (goal, value) => {
			dispatch(actions.change(`project.registry.data.goals[${goal}].resource_concept_id`, value))
		},
		addGeoArea: (goal, value) => {
			dispatch(actions.change(`project.registry.data.goals[${goal}].geographic_area`, value))
		},
		addProjectGoalMuns: (goal, mun) => {
			dispatch(actions.push(`project.registry.data.goals[${goal}].municipalities`, mun))
		},
		removeProjectGoalMuns: (goal, mun) => {
			dispatch(actions.remove(`project.registry.data.goals[${goal}].municipalities`, mun))
		},
		addProjectConagoClause: (goal, clause) => {
			dispatch(actions.push(`project.registry.data.goals[${goal}].conago_clauses`, clause))
		},
		removeProjectConagoClause: (goal, clause) => {
			dispatch(actions.remove(`project.registry.data.goals[${goal}].conago_clauses`, clause))
		},
		addProjectActor: (goal, actor) => {
			dispatch(actions.push(`project.registry.data.goals[${goal}].actors`, actor))
		},
		removeProjectActor: (goal, actor) => {
			dispatch(actions.remove(`project.registry.data.goals[${goal}].actors`, actor))
		},
		addProjectKey: (value) => {
			dispatch(actions.change('project.activity',value))
		},
		removeProjectGoal: (index) => {
			dispatch(actions.remove('project.registry.data.goals',index))
		},
		removeProjectActivity: (goal, activity) => {
			dispatch(actions.remove(`project.registry.data.goals[${goal}].activities`,activity))
		},*/
		fetchActorsList: () =>{
			dispatch(actorsList())
		},
		actorsGroups: () => {
			dispatch(actorsGroups())
		},
		fetchConagoList: () => {
			dispatch(conagoList())
		},
		fetchRegistry: (modality, state, mun) => {
			dispatch(projectRegistry(modality, state, mun))
		},
		projectRegistryData: (modality, state, mun) => {
			dispatch(projectRegistryData(modality, state, mun, undefined))
		},
		saveRegistry: (modality, state, mun, data) => {
			dispatch(projectRegistrySave(modality, state, mun, data))
		},
		fetchResourseConcepts: () => {
			dispatch(resourceConceptsList())
		},/*
		setProjectGoalTotal: (goal, total) => {
			dispatch(actions.change(`project.registry.goals[${goal}].total`, total))
		},
		addActivities: (model, value) => {
			dispatch(actions.push(model,value))
		},*/
		fetchGoalActivities: (goal) => {
			dispatch(goalActivitiesList(goal));
		},
		projectProigualdadGoals: (page, modality, state, mun) => {
			dispatch(projectProigualdadGoals(page, modality, state, mun))
		},
		projectProigualdadGoalsEdit: (goal, modality, state, mun) => {
			dispatch(projectProigualdadGoalsEdit(goal, modality, state, mun))
		},
		projectProigualdadGoalsEditSave: (goal, modality, state, mun, values) => {
			dispatch(projectProigualdadGoalsEditSave(goal, modality, state, mun, values))
		},
		clearNotification: () => {
			dispatch(clearNotification());
		},
		projectExpenses: (modality, state, mun) => {
			dispatch(projectExpenses(modality, state, mun))
		},
		projectExpensesSave: (modality, state, mun, data) => {
			dispatch(projectExpensesSave(modality, state, mun, data))
		},
		/*fetchEmployeesRoles: (modality, state, mun) => {

			dispatch(projectEmployeesRoles(modality, state, mun));
		},*/
		projectEmployees: (modality, state, mun) => {
			dispatch(projectEmployees(modality, state, mun));
		},
		resetEmployee: () => {
			dispatch(actions.change('project.profiles.data.employee.edit', {}))
		},
		projectEmployeeSave: (modality, state, mun, values) => {
			dispatch(projectEmployeeSave(modality, state, mun, values))
		},
		fetchRevisions: (modality, state, mun) => {
			dispatch(fetchRevision(modality, state, mun))
		},
		fetchRevisionLegal: (modality, state, mun) => {
			dispatch(fetchRevisionLegal(modality, state, mun))
		},
		fetchRevisionProject: (modality, state, mun) => {
			dispatch(fetchRevisionProject(modality, state, mun))
		},
		fetchRevisionReports: (slug, modality, state, mun) => {
			dispatch(fetchRevisionReports(slug, modality, state, mun))
		},
		saveLegalRevision: (modality, state, mun, values) => {
			dispatch(saveLegalRevision(modality, state, mun, values))
		},
		saveProjectRevision: (modality, state, mun, values) => {
			dispatch(saveProjectRevision(modality, state, mun, values))
		},
		fetchRevisionAgreements: (type, modality, state, mun) => {
			dispatch(fetchRevisionAgreements(type, modality, state, mun))
		},
		saveAgreements: (modality, state, mun, type, values) => {
			dispatch(saveAgreements(modality, state, mun, type, values))
		},
		saveRevisionReportsFinancial: (modality, state, mun, values) => {
			dispatch(saveRevisionReportsFinancial(modality, state, mun, values))
		},
		saveRevisionReportsExpenses: (modality, state, mun, values) => {
			dispatch(saveRevisionReportsExpenses(modality, state, mun, values))
		},
		saveRevisionReportsSummary: (modality, state, mun, values) => {
			dispatch(saveRevisionReportsSummary(modality, state, mun, values))
		},
		fetchCompletProject: (modality, state, mun) => {
			dispatch(fetchCompletProject(modality, state, mun));
		},
		fetchNotificationMessages: (modality) => {
			dispatch(notificationMessagesFetch(modality))
		},
		add: (model,item) => {
			return dispatch(actions.push(model,item))
		},
		notificationMessagesSave: (values, modality) => {
			dispatch(notificationMessagesSave(values, modality))
		},
		notificationStateReviewedSave: (value, modality, state) => {
			dispatch(notificationStateReviewedSave(value, modality, state))
		},
		notificationAssignFolios: (modality) => {
			dispatch(notificationAssignFolios(modality))
		},
		notificationMessagesExport: (modality) => {
			dispatch(notificationMessagesExport(modality))
		},
		loadFormData: (model, values) => {
			dispatch(actions.resetErrors(model));
			dispatch(actions.load(model, values));
		},
		setSystemNotification: (title, content, type) => {
			dispatch(newNotification({title: title, content: content, type: type}))
		},
		surveysShow: (page) => {
			dispatch(surveysShow(page))
		},
		fetchSurveysList: () => {
			dispatch(fetchSurveysList())
		},
		surveysFetchTypes: () => {
			dispatch(surveysFetchTypes())
		},
		fetchSurvey: (id) => {
			dispatch(fetchSurvey(id))
		},/*
		surveysCreate: (values) => {
			dispatch(surveysCreate(values))
		},*/
		surveySave: (values) => {
			dispatch(surveySave(values))
		},
		surveysClear: () => {
			dispatch(actions.reset('surveys.edit'))
		},
		surveysSaveAnswer: (values) => {
			dispatch(surveysSaveAnswer(values))
		},
		surveyDelete: (id) => {
			dispatch(surveyDelete(id))
		},
		remove: (model,index) => {
			dispatch(actions.remove(model,index))
		},
		fetchCommission: () => {
			dispatch(fetchCommission())
		},
		assignCommission: () => {
			dispatch(assignCommission())
		},
		fetchShowCommission: (modality, state, mun) => {
			dispatch(fetchShowCommission(modality, state, mun))
		},
		notificationTypesFetch: () => {
			dispatch(notificationTypesFetch())
		},
		fetchNotificationsTypes: (page) => {
			dispatch(fetchNotificationsTypes(page))
		},
		fetchNotificationsTypesList: ()=> {
			dispatch(fetchNotificationsTypesList())
		},
		notificationTypeEdit: (id) => {
			dispatch(notificationTypeEdit(id))
		},
		notificationTypeEditSave: (values) => {
			dispatch(notificationTypeEditSave(values))
		},
		projectAgreements: (modality, state, mun) => {
			dispatch(projectAgreements(modality, state, mun))
		},
		fetchProjectAgreementsWithRevision: (modality, state, mun, type) => {
			dispatch(fetchProjectAgreementsWithRevision(modality, state, mun, type))
		},
		projectAgreementsSave: (modality, state, mun, values) => {
			dispatch(projectAgreementsSave(modality, state, mun, values))
		},
		projectAgreementsExport: (modality, state, mun) => {
			dispatch(projectAgreementsExport(modality, state, mun))
		},
		/*projectFiscalEntity: (modality, state, mun) => {
			dispatch(projectFiscalEntity(modality, state, mun))
		},
		projectFiscalEntitySave: (modality, state, mun, values) => {
			dispatch(projectFiscalEntitySave(modality, state, mun, values))
		},*/
		/*fetchDispersions: (modality, state, mun) => {
			dispatch(fetchDispersions(modality, state, mun))
		},
		projectDispersionsSave: (modality, state, mun, values) => {
			dispatch(projectDispersionsSave(modality, state, mun, values))
		},*/
		projectDispersions: (modality, state, mun) => {
			dispatch(projectDispersions(modality, state, mun))
		},
		projectDispersionsExport: (modality, state, mun) => {
			dispatch(projectDispersionsExport(modality, state, mun))
		},
		projectDispersionsSave: (modality, state, mun, values) => {
			dispatch(projectDispersionsSave(modality, state, mun, values))
		},
		fetchProjects: (page, filters, search) => {
			dispatch(fetchProjects(page, filters, search))
		},
		fetchProjectsList: (value) => {
			dispatch(fetchProjectsList(value))
		},
		projectsExport: (filters, options) => {
			dispatch(projectsExport(filters, options))
		},
		fetchProjectEdit: (id) => {
			dispatch(fetchProjectEdit(id))
		},
		projectSave: (values) => {
			dispatch(projectSave(values))
		},
		fetchProjectsGoalsEdit: (id) => {
			dispatch(fetchProjectsGoalsEdit(id))
		},
		projectGoalsSave: (id, values) => {
			dispatch(projectGoalsSave(id, values))
		},
		fetchProjectsExpensesEdit: (id) => {
			dispatch(fetchProjectsExpensesEdit(id))
		},
		projectsExpensesSave: (id, values) => {
			dispatch(projectsExpensesSave(id, values))
		},
		fetchProjectPhasesGroupsEdit: (id) => {
			dispatch(fetchProjectPhasesGroupsEdit(id))
		},
		projectPhaseSave: (project_id, values) => {
			dispatch(projectPhaseSave(project_id, values))
		},
		projectPhaseDelete: (id, phaseId) => {
			dispatch(projectPhaseDelete(id, phaseId))
		},
		fetchProjectEmployeesEdit: (id) => {
			dispatch(fetchProjectEmployeesEdit(id))
		},
		projectEmployeeEditSave: (id, values) => {
			dispatch(projectEmployeeEditSave(id, values))
		},
		projectEmployeeDelete: (id, employee_id) => {
			dispatch(projectEmployeeDelete(id, employee_id))
		},
		fetchProjectCommission: (id) => {
			dispatch(fetchProjectCommission(id))
		},
		projectsFolios: (mod) => {
			dispatch(projectsFolios(mod))
		},
		projectsFoliosAssign: (mod) => {
			dispatch(projectsFoliosAssign(mod))
		},
		fetchGroupsPhasesShow: (page) => {
			dispatch(fetchGroupsPhasesShow(page))
		},
		fetchGroupsPhasesList: () => {
			dispatch(fetchGroupsPhasesList())
		},
		fetchGroupPhaseEdit: (id) => {
			dispatch(fetchGroupPhaseEdit(id))
		},
		resetGroupsPhases: () => {
			dispatch(actions.reset('groupsPhases.edit'))
		},
		groupPhaseSave: (values) => {
			dispatch(groupPhaseSave(values))
		},
		groupPhaseDelete: (id) => {
			dispatch(groupPhaseDelete(id))
		},
		reset: (model) => {
			dispatch(actions.reset(model))
		},
		reportsFinancial: (modality, state, mun) => {
			dispatch(reportsFinancial(modality, state, mun))
		},
		financialGoalStatusSave: (values, data,modality, state, mun) => {
			dispatch(financialGoalStatusSave(values, data,modality, state, mun))
		},
		financialGoalDocumentSave: (values, data,modality, state, mun) => {
			dispatch(financialGoalDocumentSave(values, data,modality, state, mun))
		},
		financialActivityStatusSave: (values, data,modality, state, mun) => {
			dispatch(financialActivityStatusSave(values, data,modality, state, mun))
		},
		financialGoalInvoicesSave: (values, data,modality, state, mun) => {
			dispatch(financialGoalInvoicesSave(values, data,modality, state, mun))
		},
		financialActivityMediaSave: (values, data,modality, state, mun) => {
			dispatch(financialActivityMediaSave(values, data,modality, state, mun))
		},
		financialGoalDocumentDelete: (values, data, id, modality, state, mun) => {
			dispatch(financialGoalDocumentDelete(values, data, id, modality, state, mun))
		},
		financialGoalInvoiceDelete: (values, data, id, modality, state, mun) => {
			dispatch(financialGoalInvoiceDelete(values, data, id, modality, state, mun))
		},
		financialActivityMediaDelete: (values, data, id, modality, state, mun) => {
			dispatch(financialActivityMediaDelete(values, data, id, modality, state, mun))
		},
		financialGoalActorsSave: (values, data,modality, state, mun) => {
			dispatch(financialGoalActorsSave(values, data,modality, state, mun))
		},
		financialGoalConagoSave: (values, data,modality, state, mun) => {
			dispatch(financialGoalConagoSave(values, data,modality, state, mun))
		},
		reportsExpenses: (modality, state, mun) => {
			dispatch(reportsExpenses(modality, state, mun))
		},
		expenseInvoicesSave: (modality, state, mun, values) => {
			dispatch(expenseInvoicesSave(modality, state, mun, values))
		},
		expensesInvoiceDelete: (values, id, modality, state, mun) => {
			dispatch(expensesInvoiceDelete(values, id, modality, state, mun))
		},
		expenseReceiptsSave: (modality, state, mun, values) => {
			dispatch(expenseReceiptsSave(modality, state, mun, values))
		},
		expensesReceiptDelete: (values, id, modality, state, mun) => {
			dispatch(expensesReceiptDelete(values, id, modality, state, mun))
		},
		reportsEmployees: (modality, state, mun) => {
			dispatch(reportsEmployees(modality, state, mun))
		},
		reportsEmployeeAdd: (values, modality, state, mun) => {
			dispatch(reportsEmployeeAdd(values, modality, state, mun))
		},
		reportsEmployeeInvoicesSave: (values, modality, state, mun) => {
			dispatch(reportsEmployeeInvoicesSave(values, modality, state, mun))
		},
		reportsEmployeeInvoiceDelete: (values, id, modality, state, mun) => {
			dispatch(reportsEmployeeInvoiceDelete(values, id, modality, state, mun))
		},
		reportsSummary: (modality, state, mun) => {
			dispatch(reportsSummary(modality, state, mun))
		},
		reportsSummaryExport: (modality, state, mun) => {
			dispatch(reportsSummaryExport(modality, state, mun))
		},
		reportsSummarySave: (values, modality, state, mun) => {
			dispatch(reportsSummarySave(values, modality, state, mun))
		},
		reportsSurvey: (modality, state, mun) => {
			dispatch(reportsSurvey(modality, state, mun))
		},
		reportsSurveySave: (values, modality, state, mun) => {
			dispatch(reportsSurveySave(values, modality, state, mun))
		},
		resetValidity: (model) => {
			dispatch(actions.resetValidity(model))
		},
		omit: (model, props) => {
			dispatch(actions.omit(model, props))
		},
		showMenu: () => {
			dispatch(showMenu())
		},
		hideMenu: () => {
			dispatch(hideMenu())
		},
		documentsTypesShow: () => {
			dispatch(documentsTypesShow())
		},
		cdmEmployees: (state) => {
			dispatch(cdmEmployees(state))
		},
		cdmEmployeesSave: (state, values) => {
			dispatch(cdmEmployeesSave(state, values))
		}
	}
}



// WEBPACK FOOTER //
// ./src/templates/secure.jsx